import request from "utils/request";

export async function addAccountProfile(payload) {
	return request("/rest/profile", {
		method: "PUT",
		body: payload
	});
}

export async function getAccountProfiles(campaignId) {
	return request("/rest/profiles/" + campaignId);
}

export async function renameAccountProfile(payload) {
	return request("/rest/profile/" + payload.id, {
		method: "POST",
		body: payload
	});
}

export async function deleteAccountProfiles(payload) {
	return request("/rest/profiles/" + payload.campaignId, {
		method: "DELETE",
		body: payload.ids
	});
}

export async function getAccounts(accountProfileId) {
	return request("/rest/accounts/" + accountProfileId);
}

export async function deleteAccounts(accountProfileId, accountIds) {
	return request("/rest/accounts/" + accountProfileId, {
		method: "DELETE",
		body: accountIds
	});
}

export async function addAccount(account) {
	return request("/rest/account", {
		method: "PUT",
		body: account
	});
}
